<template>
  <div class="custom-checkbox" :class="{ 'custom-checkbox-disabled': value === false }">
    <input type="checkbox" :checked="value" disabled id="checkbox1" autocomplete="off">
    <label for="checkbox1" v-if="value"></label>
  </div>
</template>

<script>
export default {
  name: 'CustomCheckBox',
  props: {
    value: Boolean
  }
}
</script>

<style scoped>
.custom-checkbox {
  position: relative;
  width: 20px;
  height: 20px;
  background-color: #fb6340;
  border-radius: 0.2rem;
}

.custom-checkbox input {
  opacity: 0;
  width: 100%;
  height: 100%;
}

.custom-checkbox label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.custom-checkbox label::after {
  content: '';
  position: absolute;
  left: 5px;
  top: 4px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.custom-checkbox-disabled {
  background-color: white;
  border: 1px solid #ccc;
}
</style>
